import * as Sentry from "@sentry/react"

interface ErrorContext {
  apiEndpoint: string;
  httpMethod: string;
  component: string;
  url: string;
}
export const captureApiError = (error: unknown, context: ErrorContext): void => {
  Sentry.captureException(error, {
    tags: {
      api_endpoint: context.apiEndpoint,
      http_method: context.httpMethod,
      component: context.component
    },
    extra: {
      url: context.url,
      error: error instanceof Error ? error.message : String(error),
      timestamp: new Date().toISOString()
    }
  });
};


